<template>
    <div id="contact">
        <normal-header :data="header" />
        <div id = "contact-content"> 
            <ContactMap></ContactMap>
            <ContactForm></ContactForm>
            <div class="columns is-centered">
                <div class="column is-3" v-for="(person, index) in contactPeople" :key="index">
                    <ContactPersonCard 
                        :contactPerson="person"></ContactPersonCard>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NormalHeader from '@/components/global-components/NormalHeader'
import ContactForm from '@/components/contact-components/ContactForm'
import ContactMap from '@/components/contact-components/ContactMap'
import ContactPersonCard from '@/components/cards/ContactPersonCard'
import contactPeople from '@/assets/resources/contactPerson.js'

export default {
 components: {
    ContactPersonCard,
    ContactForm,
    ContactMap,
    NormalHeader
 },
 data() {
     return {
        contactPeople,
        header: {
            transparent: false
        }
     }
 }
}
</script>

<style lang="scss" scoped>
.columns{
    margin-bottom: 5vh;
}

#contact {
    &-content {
        @extend %eestec-page;
    }
}
</style>